/* ==========================================================================
   VEYRA — storefront behaviour
   Vanilla, no dependencies. Every feature binds by data-attribute so markup
   stays declarative and a missing element never throws.
   ========================================================================== */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = (window.VEYRA && window.VEYRA.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' };
  const root = R.root.endsWith('/') ? R.root : R.root + '/';
  const CART_SECTION = 'veyra-cart-drawer';

  /* ---------------- money ---------------- */
  const money = (cents) => {
    const fmt = (window.VEYRA && window.VEYRA.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount\s*\}\}/, two).replace(/<[^>]+>/g, '');
  };

  /* ---------------- toast ---------------- */
  let toastT;
  const toast = (msg) => {
    const t = $('[data-o-toast]');
    if (!t) return;
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m5 12 5 5 9-10"/></svg>' + msg;
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
  };

  /* ---------------- overlay + panels ---------------- */
  const overlay = $('[data-o-overlay]');
  let openPanel = null;
  let lastFocus = null;

  const lock = (on) => document.body.classList.toggle('o-locked', on);

  function open(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) close(true);
    lastFocus = document.activeElement;
    openPanel = panel;
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-on')); }
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    lock(true);
    const f = panel.querySelector('[data-o-autofocus]') || panel.querySelector('button, a, input');
    setTimeout(() => f && f.focus({ preventScroll: true }), 60);
    $$('[aria-controls="' + panel.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
  }
  function close(silent) {
    if (!openPanel) return;
    const p = openPanel;
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + p.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openPanel = null;
    if (!silent) {
      if (overlay) { overlay.classList.remove('is-on'); setTimeout(() => { if (!openPanel) overlay.hidden = true; }, 350); }
      lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-o-open]');
    if (opener) {
      e.preventDefault();
      const p = document.getElementById(opener.getAttribute('data-o-open'));
      if (p && p.classList.contains('is-open')) close(); else open(p);
      return;
    }
    if (e.target.closest('[data-o-close]') || e.target === overlay) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // focus trap
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !openPanel) return;
    const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', openPanel).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- header: hide on scroll down ---------------- */
  const hdr = $('.o-header-sec');
  if (hdr) {
    let lastY = window.scrollY, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      const hide = y > 240 && y > lastY + 4 && !openPanel && !$('.o-nav__item.is-open');
      const show = y < lastY - 4 || y < 120;
      if (hide) { hdr.classList.add('is-hidden'); document.body.classList.add('o-hdr-hidden'); }
      else if (show) { hdr.classList.remove('is-hidden'); document.body.classList.remove('o-hdr-hidden'); }
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    const setH = () => document.documentElement.style.setProperty('--header-h', ($('.o-header__in') || hdr).offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
  }

  /* ---------------- announcement rotation ---------------- */
  $$('[data-o-ann]').forEach((track) => {
    const msgs = $$('.o-ann__msg', track);
    if (msgs.length < 2) { msgs[0] && msgs[0].classList.add('is-on'); return; }
    let i = 0; msgs[0].classList.add('is-on');
    setInterval(() => {
      const cur = msgs[i]; i = (i + 1) % msgs.length; const nx = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      nx.classList.remove('is-out'); nx.classList.add('is-on');
      setTimeout(() => cur.classList.remove('is-out'), 600);
    }, 4200);
  });

  /* ---------------- mega menu ---------------- */
  $$('.o-nav__item[data-o-mega]').forEach((item) => {
    let t;
    const link = $('.o-nav__link', item);
    const on = () => { clearTimeout(t); $$('.o-nav__item.is-open').forEach((x) => x !== item && x.classList.remove('is-open')); item.classList.add('is-open'); link && link.setAttribute('aria-expanded', 'true'); };
    const off = () => { t = setTimeout(() => { item.classList.remove('is-open'); link && link.setAttribute('aria-expanded', 'false'); }, 140); };
    item.addEventListener('mouseenter', on);
    item.addEventListener('mouseleave', off);
    item.addEventListener('focusin', on);
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) off(); });
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { item.classList.remove('is-open'); link && link.focus(); } });
  });

  /* ---------------- mobile nav accordion ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-o-mnav-toggle]');
    if (!b) return;
    const row = b.closest('.o-mnav__row');
    const openNow = !row.classList.contains('is-open');
    row.classList.toggle('is-open', openNow);
    b.setAttribute('aria-expanded', String(openNow));
  });

  /* ---------------- reveal + meters ---------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    const scan = (r = document) => $$('.o-reveal:not(.is-in), .o-meter:not(.is-in)', r).forEach((el) => io.observe(el));
    scan();
    window.VEYRA_scan = scan;
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
  } else {
    $$('.o-reveal, .o-meter').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------------- rails ---------------- */
  function bindRail(rail) {
    if (rail.dataset.bound) return; rail.dataset.bound = '1';
    const track = $('.o-rail__track', rail);
    const bar = $('.o-rail__bar', rail);
    const scope = rail.closest('[data-o-rail-scope]') || rail.parentElement;
    const prev = $('[data-o-prev]', scope), next = $('[data-o-next]', scope);
    if (!track) return;
    const upd = () => {
      const max = track.scrollWidth - track.clientWidth;
      const vis = track.clientWidth / track.scrollWidth;
      if (bar) {
        bar.style.width = Math.max(vis * 100, 8) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(vis, .08)) - 1) * 100 : 0) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      const pr = $('.o-rail__progress', rail); if (pr) pr.style.visibility = max > 4 ? 'visible' : 'hidden';
    };
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth; };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  const scanRails = (r = document) => $$('[data-o-rail]', r).forEach(bindRail);
  scanRails();

  /* ---------------- tabs ---------------- */
  $$('[data-o-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const select = (t, focus) => {
      tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; const p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      if (focus) t.focus();
      const p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) { $$('[data-o-rail]', p).forEach((r) => { delete r.dataset.bound; bindRail(r); }); window.VEYRA_scan && window.VEYRA_scan(p); }
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      });
    });
  });

  /* ==========================================================================
     CART
     ========================================================================== */
  const drawer = () => document.getElementById('o-cart');

  function setCount(n) {
    $$('[data-o-count]').forEach((c) => {
      c.textContent = n; c.classList.toggle('is-on', n > 0);
      c.classList.remove('is-bump'); void c.offsetWidth; if (n > 0) c.classList.add('is-bump');
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-o-cart-inner]');
    const cur = document.querySelector('[data-o-cart-inner]');
    // read the count before the node is moved out of the parsed document
    const n = fresh ? parseInt(fresh.getAttribute('data-o-cart-count'), 10) || 0 : null;
    if (fresh && cur) cur.replaceWith(fresh);
    if (n !== null) setCount(n);
  }

  async function refreshDrawer() {
    const r = await fetch(root + '?sections=' + CART_SECTION);
    const j = await r.json();
    renderDrawer(j[CART_SECTION]);
  }

  async function addToCart(items, opts = {}) {
    const res = await fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: CART_SECTION, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
    if (data.sections) renderDrawer(data.sections[CART_SECTION]); else await refreshDrawer();
    if (opts.open !== false) open(drawer());
    else toast((window.VEYRA.strings && window.VEYRA.strings.added) || 'Added to bag');
    return data;
  }
  window.VEYRA_add = addToCart;

  async function changeLine(key, quantity) {
    const inner = document.querySelector('[data-o-cart-inner]');
    inner && inner.classList.add('is-busy');
    try {
      const res = await fetch(R.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: CART_SECTION, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Update failed');
      if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
      renderDrawer(data.sections && data.sections[CART_SECTION]);
    } catch (err) { toast(err.message); inner && inner.classList.remove('is-busy'); }
  }

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-o-qty]');
    if (q) {
      e.preventDefault();
      const key = q.getAttribute('data-key');
      const cur = parseInt(q.getAttribute('data-cur'), 10) || 0;
      const d = q.getAttribute('data-o-qty');
      changeLine(key, d === 'rm' ? 0 : Math.max(0, cur + (d === '+' ? 1 : -1)));
      return;
    }
    const up = e.target.closest('[data-o-add-id]');
    if (up) {
      e.preventDefault();
      up.classList.add('is-loading');
      addToCart([{ id: +up.getAttribute('data-o-add-id'), quantity: 1 }], { open: up.hasAttribute('data-o-open-cart') || !!up.closest('#o-cart') })
        .catch((err) => toast(err.message))
        .finally(() => up.classList.remove('is-loading'));
    }
  });

  // any form[data-o-cart-form] (PDP) → ajax
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-o-cart-form]');
    if (!f) return;
    e.preventDefault();
    const idInput = f.querySelector('input[name="id"]');
    const msg = f.querySelector('[data-o-size-msg]');
    if (!idInput || !idInput.value) {
      if (msg) msg.textContent = (window.VEYRA.strings && window.VEYRA.strings.choose) || 'Select a size';
      const first = f.querySelector('.o-sizes');
      first && first.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
      return;
    }
    const btns = $$('[data-o-atc]');
    btns.forEach((b) => b.classList.add('is-loading'));
    const qty = parseInt((f.querySelector('input[name="quantity"]') || {}).value || '1', 10);
    addToCart([{ id: +idInput.value, quantity: qty }])
      .catch((err) => { if (msg) msg.textContent = err.message; else toast(err.message); })
      .finally(() => btns.forEach((b) => b.classList.remove('is-loading')));
  });

  /* ---------------- product card quick add ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-o-quick]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    b.disabled = true;
    addToCart([{ id: +b.getAttribute('data-o-quick'), quantity: 1 }])
      .catch((err) => toast(err.message))
      .finally(() => { b.disabled = false; });
  });

  /* ==========================================================================
     PDP — variants, gallery, sticky bar, modals
     ========================================================================== */
  $$('[data-o-product]').forEach((pdp) => {
    const json = $('script[data-o-variants]', pdp);
    const variants = json ? JSON.parse(json.textContent) : [];
    const form = $('form[data-o-cart-form]', pdp);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-o-price]', pdp);
    const chosenEl = $('[data-o-chosen]', pdp);
    const msg = $('[data-o-size-msg]', pdp);
    const btns = $$('[data-o-atc]');
    const stickyLabel = $('[data-o-sticky-label]');

    const labelFor = (v) => {
      if (!v) return (window.VEYRA.strings.choose || 'Select a size');
      if (!v.available) return window.VEYRA.strings.soldOut || 'Sold out';
      return (window.VEYRA.strings.add || 'Add to bag') + ' — ' + money(v.price);
    };
    const paint = (v) => {
      btns.forEach((b) => {
        const l = $('[data-o-atc-label]', b) || b;
        l.textContent = labelFor(v);
        b.disabled = !!(v && !v.available);
      });
      if (stickyLabel) stickyLabel.textContent = v ? v.title : '';
      if (v && priceEl) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<span>' + money(v.price) + '</span>';
      }
      if (chosenEl) chosenEl.textContent = v ? v.option1 : '';
      if (v && v.available && msg) msg.textContent = '';
      if (msg) msg.textContent = '';
    };

    const syncUrl = (v) => {
      if (!v) return;
      const u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u.toString());
    };

    /* multi-option products (ex.: Size + Color): casa a combinação escolhida.
       Achatar variantes num único grupo duplicaria "XS XS S S". */
    const optInputs = $$('input[data-o-opt]', pdp);
    const chosenOptEls = $$('[data-o-chosen-opt]', pdp);

    const readOpts = () => {
      const chosen = [];
      $$('input[data-o-opt]:checked', pdp).forEach((i) => { chosen[+i.dataset.oOpt] = i.value; });
      return chosen;
    };
    const matchVariant = (chosen) => variants.find((x) =>
      Array.isArray(x.options) && x.options.length === chosen.length &&
      x.options.every((o, i) => o === chosen[i]));

    const applyOpts = () => {
      const chosen = readOpts();
      chosenOptEls.forEach((el) => { el.textContent = chosen[+el.dataset.oChosenOpt] || ''; });
      const complete = chosen.length === chosenOptEls.length && chosen.every(Boolean);
      const v = complete ? matchVariant(chosen) : null;
      if (idInput) idInput.value = v ? v.id : '';
      paint(v);
      if (complete && !v && msg) msg.textContent = 'That combination is not available.';
      syncUrl(v);
    };

    pdp.addEventListener('change', (e) => {
      if (e.target.closest('input[data-o-opt]')) { applyOpts(); return; }
      const r = e.target.closest('input[data-o-variant]');
      if (!r) return;
      const v = variants.find((x) => String(x.id) === r.value);
      if (idInput) idInput.value = r.value;
      paint(v);
      syncUrl(v);
    });

    // single-variant products auto-select
    if (variants.length === 1 && idInput) { idInput.value = variants[0].id; paint(variants[0]); }
    else if (optInputs.length) { applyOpts(); }
    else {
      const pre = $('input[data-o-variant]:checked', pdp);
      if (pre) { idInput.value = pre.value; paint(variants.find((x) => String(x.id) === pre.value)); }
      else paint(null);
    }

    // sticky bar mirrors the form
    const sticky = $('[data-o-sticky]');
    const anchor = $('[data-o-atc-anchor]', pdp);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
      }).observe(anchor);
      const sb = $('[data-o-atc]', sticky);
      sb && sb.addEventListener('click', (e) => {
        e.preventDefault();
        if (!idInput.value) { anchor.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (msg) msg.textContent = window.VEYRA.strings.choose; return; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    // gallery dots (mobile)
    const track = $('.o-gal__track', pdp);
    const dots = $$('.o-gal__dots button', pdp);
    if (track && dots.length) {
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }, { passive: true });
      dots.forEach((d, n) => d.addEventListener('click', () => track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' })));
    }

    // zoom
    const zoom = $('#o-zoom'); const zimg = zoom && $('img', zoom);
    $$('.o-gal__slide img', pdp).forEach((im) => im.addEventListener('click', () => {
      if (window.innerWidth < 1000 || !zoom) return;
      zimg.src = im.getAttribute('data-full') || im.currentSrc; zimg.alt = im.alt;
      open(zoom);
    }));
  });

  /* ---------------- wish (local) ---------------- */
  const WK = 'veyra-wish';
  const wishes = () => { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } };
  $$('[data-o-wish]').forEach((b) => {
    const id = b.getAttribute('data-o-wish');
    const set = () => { const on = wishes().includes(id); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); };
    set();
    b.addEventListener('click', () => {
      let w = wishes(); w = w.includes(id) ? w.filter((x) => x !== id) : w.concat(id);
      localStorage.setItem(WK, JSON.stringify(w)); set();
      toast(w.includes(id) ? 'Saved for later' : 'Removed from saved');
    });
  });

  /* ==========================================================================
     SEARCH — predictive
     ========================================================================== */
  const sBox = document.getElementById('o-search');
  if (sBox) {
    const input = $('.o-search__input', sBox);
    const results = $('[data-o-search-results]', sBox);
    const idle = $('[data-o-search-idle]', sBox);
    let ctrl, t;
    const run = async (q) => {
      if (!q) { results.innerHTML = ''; results.hidden = true; idle.hidden = false; return; }
      ctrl && ctrl.abort(); ctrl = new AbortController();
      try {
        const r = await fetch(R.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=veyra-predictive', { signal: ctrl.signal });
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-o-pred]');
        results.innerHTML = inner ? inner.innerHTML : '';
        results.hidden = false; idle.hidden = true;
      } catch (e) { /* aborted */ }
    };
    input && input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => run(input.value.trim()), 180); });
  }

  /* ==========================================================================
     COLLECTION — filters & sort (form → URL)
     ========================================================================== */
  $$('form[data-o-filters]').forEach((f) => {
    const go = () => {
      const fd = new FormData(f);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') p.append(k, v); }
      const sort = $('[data-o-sort]');
      if (sort && sort.value) p.set('sort_by', sort.value);
      window.location.search = p.toString();
    };
    f.addEventListener('change', (e) => { if (e.target.matches('input[type="checkbox"]') && !f.hasAttribute('data-o-manual')) go(); });
    f.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  });
  $$('[data-o-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  }));

  /* ==========================================================================
     SHOE FINDER
     ========================================================================== */
  $$('[data-o-finder]').forEach((box) => {
    const data = JSON.parse(($('script[type="application/json"]', box) || {}).textContent || '{}');
    const qs = data.questions || [];
    const shoes = data.shoes || [];
    const stage = $('[data-o-finder-stage]', box);
    const steps = $$('.o-finder__steps i', box);
    const answers = [];

    const q = (i) => {
      steps.forEach((s, n) => s.classList.toggle('is-on', n <= i));
      const Q = qs[i];
      stage.innerHTML = '<p class="o-eyebrow">Question ' + (i + 1) + ' of ' + qs.length + '</p>' +
        '<h3 class="o-finder__q" style="margin-top:14px">' + Q.q + '</h3>' +
        '<div class="o-finder__opts">' + Q.opts.map((o, n) => '<button type="button" class="o-opt" data-n="' + n + '"><b>' + o.t + '</b><span>' + o.d + '</span></button>').join('') + '</div>' +
        (i > 0 ? '<button type="button" class="o-finder__back" data-back>Back</button>' : '');
      $$('.o-opt', stage).forEach((b) => b.addEventListener('click', () => {
        answers[i] = Q.opts[+b.dataset.n].k;
        if (i + 1 < qs.length) q(i + 1); else result();
      }));
      const bk = $('[data-back]', stage); bk && bk.addEventListener('click', () => q(i - 1));
    };

    const result = () => {
      steps.forEach((s) => s.classList.add('is-on'));
      let best = null, bestScore = -1;
      shoes.forEach((s) => {
        let sc = 0; answers.forEach((a) => { if ((s.keys || []).includes(a)) sc++; });
        if (sc > bestScore) { bestScore = sc; best = s; }
      });
      if (!best) return;
      stage.innerHTML = '<p class="o-eyebrow"><span class="o-eyebrow__dot"></span>Your match</p>' +
        '<div class="o-finder__res" style="margin-top:18px">' +
        '<a class="o-finder__res-img" href="' + best.url + '"><img src="' + best.img + '" alt="' + best.title + '" loading="lazy"></a>' +
        '<div><h3 class="o-h3">' + best.title + '</h3><p class="o-finder__why">' + best.why + '</p>' +
        '<div class="o-finder__ctas"><a class="o-btn" href="' + best.url + '">Shop ' + best.short + ' — ' + best.price + '</a>' +
        '<button type="button" class="o-btn o-btn--outline" data-restart>Start again</button></div></div></div>';
      $('[data-restart]', stage).addEventListener('click', () => { answers.length = 0; q(0); });
    };
    if (qs.length) q(0);
  });

  /* ---------------- newsletter feedback (native form posts, we just keep it tidy) ---------------- */
  $$('form[data-o-news]').forEach((f) => f.addEventListener('submit', () => { const b = $('button', f); b && b.classList.add('is-loading'); }));

  /* ---------------- theme editor ---------------- */
  document.addEventListener('shopify:section:load', (e) => { scanRails(e.target); });
})();
